import React from 'react';
import Text from 'components/Text';
import formatRankForDisplay from 'utils/ui/formatRankForDisplay';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function Ranking(_ref) {
  var rank = _ref.rank;
  if (!rank) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      mr: ['xxxs', 'xxs'],
      breakpoints: "xs",
      dimmed: true,
      children: formatRankForDisplay(rank)
    }), ' ']
  });
}
export default Ranking;